import { globalStyle, style } from '@vanilla-extract/css'
import { vars } from '~/styles/theme.css'

export const dateInputWrapper = style({
  position: 'relative',
  width: '100%',
  display: 'flex',
  alignItems: 'center'
})

export const dateInput = style({
  cursor: 'pointer',
  height: 48
})

export const dateInputClearable = style({
  paddingRight: 36
})

export const clearButton = style({
  position: 'absolute',
  right: 32,
  top: '50%',
  transform: 'translateY(-50%)',
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  color: vars.color.medium,
  display: 'flex',
  alignItems: 'center',
  padding: 0,
  opacity: 0,
  transition: 'opacity 0.15s, color 0.15s',
  zIndex: 1,

  ':hover': {
    color: vars.color.dark
  },

  ':focus-visible': {
    opacity: 1,
    outline: `2px solid ${vars.color.primary}`,
    outlineOffset: 2,
    borderRadius: 2
  },

  selectors: {
    [`${dateInputWrapper}:hover &`]: {
      opacity: 1
    }
  }
})

export const inputPlaceholder = style({
  color: vars.color.medium
})

export const calendarHeader = style({
  fontSize: vars.font.h3.size,
  fontWeight: vars.font.h3.weight,
  textTransform: 'capitalize',
  color: vars.color.darkLighter,
  margin: '0 0 24px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
})

export const monthNavigation = style({
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  color: vars.color.darkLighter,
  top: 0,
  transition: 'all 0.2s',

  ':hover': {
    color: vars.color.primary
  }
})

export const monthTitle = style({
  cursor: 'pointer'
})

export const monthNavigationDisabled = style({
  color: vars.color.inactive,
  cursor: 'not-allowed'
})

export const headerYear = style({
  color: vars.color.primary
})

export const monthYearSelect = style({
  position: 'absolute',
  inset: 0,
  backgroundColor: vars.color.white,
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  textAlign: 'center',
  gap: 24,
  padding: 24,
  flexWrap: 'wrap'
})

export const monthYearSelectItemActive = style({
  backgroundColor: vars.color.primary,
  color: vars.color.white
})

export const monthYearSelectItem = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  transition: 'all 0.2s',
  borderRadius: vars.buttons.radius,
  fontSize: vars.font.bodyBold.size,
  fontWeight: vars.font.bodyBold.weight,

  ':hover': {
    backgroundColor: vars.color.primary,
    color: vars.color.white
  }
})

/**
 * React Datepicker styles
 * Lib does not provide a way to style with vanilla extract, so we have to use global styles
 */
globalStyle('.react-datepicker-popper', {
  zIndex: 999
})

globalStyle('.react-datepicker', {
  backgroundColor: vars.color.white,
  boxShadow: vars.shadow,
  borderRadius: vars.buttons.radius,
  padding: 24,
  gap: 24,
  display: 'flex'
})

globalStyle('.react-datepicker-wrapper', {
  width: '100%'
})

globalStyle('.react-datepicker__navigation', {
  top: 24,
  border: 'none',
  backgroundColor: 'transparent',
  cursor: 'pointer'
})

globalStyle('.react-datepicker__tab-loop', {
  color: vars.color.dark
})

globalStyle('.react-datepicker__aria-live', {
  display: 'none'
})

globalStyle('.react-datepicker__month-container', {
  display: 'flex',
  flexDirection: 'column',
  gap: 16
})

globalStyle('.react-datepicker__day-names', {
  display: 'flex',
  gap: 8,
  marginBottom: 8,
  fontSize: vars.font.bodyBold.size,
  fontWeight: vars.font.bodyBold.weight,
  color: vars.color.darkLighter
})

globalStyle('.react-datepicker__day-name', {
  width: 32,
  textAlign: 'center'
})

globalStyle('.react-datepicker__month', {
  display: 'flex',
  flexDirection: 'column',
  gap: 8
})

globalStyle('.react-datepicker__current-month', {})

globalStyle('.react-datepicker__week', {
  display: 'flex',
  gap: 8
})

globalStyle('.react-datepicker__day', {
  width: 32,
  height: 32,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontFamily: 'Chivo Mono',
  fontSize: vars.font.body.size,
  fontWeight: vars.font.body.weight,
  color: vars.color.dark,
  cursor: 'pointer',
  borderRadius: 4,
  transition: 'all 0.2s'
})

globalStyle('.react-datepicker__day--in-selecting-range', {
  backgroundColor: vars.color.primaryFaded
})

globalStyle(
  '.react-datepicker__day:not(.react-datepicker__day--disabled):hover, .react-datepicker__day--selected',
  {
    backgroundColor: vars.color.primary,
    color: vars.color.white
  }
)

globalStyle('.react-datepicker__day--outside-month', {
  visibility: 'hidden'
})

globalStyle('.react-datepicker__day--disabled', {
  color: '#E2EAED',
  cursor: 'not-allowed'
})

globalStyle('.react-datepicker__header--time', {
  display: 'none'
})

globalStyle('.react-datepicker__time-container', {
  overflow: 'auto',
  scrollbarWidth: 'thin',
  maxHeight: 270,
  scrollbarColor: `${vars.color.darkLighter} transparent`
})

globalStyle('.react-datepicker__time-list', {
  margin: 0,
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  paddingRight: 8,
  listStyle: 'none'
})

globalStyle('.react-datepicker__time-list-item', {
  fontFamily: 'Chivo Mono',
  fontSize: vars.font.body.size,
  fontWeight: vars.font.body.weight,
  cursor: 'pointer',
  color: vars.color.darkLighter,
  transition: 'all 0.2s'
})

globalStyle('.react-datepicker__time-list-item--disabled', {
  display: 'none'
})

globalStyle('.react-datepicker__time-list-item:hover', {
  color: vars.color.medium
})

globalStyle('.react-datepicker__time-list-item--selected', {
  color: vars.color.primary
})

globalStyle(
  '.react-datepicker__day--weekend:not(.react-datepicker__day--disabled), .react-datepicker__day--holiday:not(.react-datepicker__day--disabled)',
  {
    color: vars.color.medium
  }
)

globalStyle(
  '.react-datepicker__day--weekend:not(.react-datepicker__day--disabled):hover, .react-datepicker__day--weekend.react-datepicker__day--selected, .react-datepicker__day--holiday:not(.react-datepicker__day--disabled):hover, .react-datepicker__day--holiday.react-datepicker__day--selected',
  {
    color: vars.color.white
  }
)

/* sr-only utility class for accessibility */
globalStyle('.react-datepicker__sr-only', {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: '0',
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: 0
})
